export const buildCategoricalBarChartData = (labels, values, colors) => ({
  categories: labels.map(label => ({ label })),
  series: labels.map((label, index) => ({
    id: `category-${index}`,
    label,
    color: colors[index],
    data: labels.map((_, categoryIndex) =>
      categoryIndex === index ? values[index] : null
    ),
  })),
});
